import React, { useEffect } from "react";
import "./IndexPage.css";
import { useState } from 'react';
import Header from "../components/Header.js"
import Footer from "../components/Footer.js"
import ReasonsToJoin2 from "../components/ReasonsToJoin2.js"
import TopIntro from "../components/TopIntro.js"
import HowItWorks from "../components/HowItWorks.js"
import ConferenceSpeaker2 from "../components/ConferenceSpeaker2.js";
import QAndA from "../components/QAndA.js";
import { Modal } from 'react-responsive-modal';
import RegisterModalBody from "../components/RegisterModalBody.js"
import ContactModalBody from "../components/ContactModalBody.js"
import ConfidentialityModalBody from "../components/ConfidentialityModalBody.js"
import MessageModalBody from "../components/MessageModalBody.js"
import HttpActionModalBody from "../components/HttpActionModalBody.js"
import TermsBody from "../components/TermsBody.js"
import { notify, logData } from "../api.js";
import 'react-responsive-modal/styles.css';
import YoutubeEmbed from "../components/YoutubeEmbed.js";
import WhoAmI from "../components/WhoAmI.js";
import CourseSummary from "../components/CourseSummary.js";
import { pingServer } from "../api.js";

const IndexPage = ({ page }) => {
    const [registerModalOpen, setRegisterModalOpen] = useState(false);
    const [contactModalOpen, setContactModalOpen] = useState(false);
    const [messageModalOpen, setMessageModalOpen] = useState(false);
    const [httpActionlModalOpen, setHttpActionModalOpen] = useState(false);

    const showRegisterDialog = (id) => {
        const referrer = document.referrer || "No referrer";
        const extraData = { referrer: referrer, id: id };
        logData("openRegister", extraData)
            .catch(() => {

            });
        setRegisterModalOpen(true);
        pingServer();
    };

    const closeRegisterDialog = () => setRegisterModalOpen(false);
    const showContactDialog = () => setContactModalOpen(true);
    const closeContactDialog = () => setContactModalOpen(false);
    const showMessageDialog = () => setMessageModalOpen(true);
    const closeMessageDialog = () => setMessageModalOpen(false);
    const showHttpActionDialog = () => setHttpActionModalOpen(true);
    const closeHttpActionDialog = () => setHttpActionModalOpen(false);

    useEffect(() => {
        if (page == "message") {
            setMessageModalOpen(true);
        }
        if (page == "contact") {
            setContactModalOpen(true);
        }
        if (page == "confirm_email") {
            setHttpActionModalOpen(true);
        }
        if (page == "unsubscribe") {
            setHttpActionModalOpen(true);
            notify(window.location);
        }
    }, []);



    return (
        <>
            <Modal animationDuration={0}
                open={registerModalOpen} onClose={closeRegisterDialog} center showCloseIcon={false} classNames={{ modal: 'modalClass' }}>
                <RegisterModalBody hideModal={closeRegisterDialog} />
            </Modal>
            <Modal animationDuration={0}
                open={contactModalOpen} onClose={closeContactDialog} center showCloseIcon={false} classNames={{ modal: 'modalClass' }}>
                <ContactModalBody hideModal={closeContactDialog} />
            </Modal>
            <Modal animationDuration={0}
                open={messageModalOpen} onClose={closeMessageDialog} center showCloseIcon={false} classNames={{ modal: 'modalClass' }}>
                <MessageModalBody hideModal={closeMessageDialog} />
            </Modal>
            <Modal animationDuration={0}
                open={httpActionlModalOpen} onClose={closeHttpActionDialog} center showCloseIcon={false} classNames={{ modal: 'modalClass' }}>
                <HttpActionModalBody hideModal={closeHttpActionDialog} page={page} />
            </Modal>


            <Header showAskAnythingDialog={showContactDialog}></Header>
            {(page == "index" || page == "message" || page == "contact" || page == "confirm_email" || page == "unsubscribe") && (
                <>
                    <TopIntro showRegisterDialogParent={showRegisterDialog}></TopIntro>
                    <HowItWorks showRegisterDialogParent={showRegisterDialog}></HowItWorks>
                    <CourseSummary showRegisterDialogParent={showRegisterDialog}></CourseSummary>
                    <ConferenceSpeaker2 showRegisterDialogParent={showRegisterDialog}></ConferenceSpeaker2>
                    <ReasonsToJoin2 showRegisterDialogParent={showRegisterDialog}></ReasonsToJoin2>
                    {/* <WhoAmI showRegisterDialogParent={showRegisterDialog}></WhoAmI> */}
                    <YoutubeEmbed showRegisterDialogParent={showRegisterDialog}></YoutubeEmbed>                    
                    <QAndA showAskAnythingDialog={showContactDialog} showRegisterDialogParent={showRegisterDialog}></QAndA>

                </>
            )}
            {(page == "terms") && (
                <>
                    <TermsBody></TermsBody>
                </>
            )}
            {(page == "confidentiality") && (
                <>
                    <ConfidentialityModalBody></ConfidentialityModalBody>
                </>
            )}


            <Footer showAskAnythingDialog={showContactDialog}></Footer>
        </>
    )
}

export default IndexPage;